import { useEffect } from "react";
export var useOnKeyPress = function useOnKeyPress(keyCode, onPress) {
  useEffect(function () {
    var keyCodes = [];
    if (typeof keyCode === "string") {
      keyCodes = [keyCode];
    } else {
      keyCodes = keyCode;
    }
    var escList = function escList(ev) {
      if (keyCodes.includes(ev.key)) {
        onPress();
      }
    };
    document.addEventListener("keydown", escList);
    return function () {
      document.removeEventListener("keydown", escList);
    };
  }, [onPress, keyCode]);
};